<template>
  <div class="hardware-main">
    <div class="hardware-box">
      <div class="hardware-title">{{ $t('hardone.performance_params') }}</div>
      <div class="hardware-li">{{ $t('hardone.cpu') }}</div>
      <div class="hardware-li">{{ $t('hardone.ram_rom') }}</div>
      <div class="hardware-li">{{ $t('hardone.expansion_memory') }}</div>
      <div class="hardware-li">{{ $t('hardone.os') }}</div>
      <div class="hardware-title">{{ $t('hardone.physical_params') }}</div>
      <div class="hardware-li">{{ $t('hardone.dimensions') }}</div>
      <div class="hardware-li">{{ $t('hardone.weight') }}</div>
      <div class="hardware-li">{{ $t('hardone.display') }}</div>
      <div class="hardware-li">{{ $t('hardone.battery') }}</div>
      <div class="hardware-title">{{ $t('hardone.camera') }}</div>
      <div class="hardware-li">{{ $t('hardone.front_camera') }}</div>
      <div class="hardware-li">{{ $t('hardone.rear_camera') }}</div>
      <div class="hardware-title">{{ $t('hardone.rfid_ghf') }}</div>
      <div class="hardware-li">{{ $t('hardone.protocol_standard1') }}</div>
      <div class="hardware-li">{{ $t('hardone.protocol_standard2') }}</div>
      <div class="hardware-li">{{ $t('hardone.frequency') }}</div>
      <div class="hardware-li">{{ $t('hardone.engine') }}</div>
      <div class="hardware-li">{{ $t('hardone.output_power') }}</div>
      <div class="hardware-li">{{ $t('hardone.antenna_params') }}</div>
      <div class="hardware-title">{{ $t('hardone.max_read_distance') }}</div>
      <div class="hardware-li">{{ $t('hardone.max_read_distance_5dBi_1') }}</div>
      <div class="hardware-li">{{ $t('hardone.max_read_distance_5dBi_2') }}</div>
      <div class="hardware-li">{{ $t('hardone.max_read_distance_5dBi_3') }}</div>
      <div class="hardware-li">{{ $t('hardone.max_read_distance_5dBi_4') }}</div>
      <div class="hardware-li">{{ $t('hardone.max_read_distance_4dBi_1') }}</div>
      <div class="hardware-li">{{ $t('hardone.max_read_distance_4dBi_2') }}</div>
      <div class="hardware-li">{{ $t('hardone.max_read_distance_4dBi_3') }}</div>
      <div class="hardware-li">{{ $t('hardone.max_read_distance_4dBi_4') }}</div>
      <div class="hardware-li">{{ $t('hardone.read_rate') }}</div>
      <div class="hardware-title">{{ $t('hardone.environment') }}</div>
      <div class="hardware-li">{{ $t('hardone.operating_temperature') }}</div>
      <div class="hardware-li">{{ $t('hardone.storage_temperature') }}</div>
      <div class="hardware-li">{{ $t('hardone.humidity') }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>